export default __webpack_public_path__ + "static/FKIE-b2660386a0221d4661ce8b8801437c57.jpeg";